export default __webpack_public_path__ + "static/media/yeopen_cube.8df0c7bd.jpg";